import { Button as ButtonBase } from "@omni/ui/components/Button/button.component";
import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { cn } from "@omni/utils/styles";

import { useOrderButtonContext } from "@/components/Product/ECommerce/components/orderButton/context/orderButton.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

type Props = Omit<ButtonComponentProps, "onClick" | "disabled" | "type">;

export const Button = ({ ...props }: Props) => {
    const { t } = useGranite();

    const { isDisabled, onSubmit } = useOrderButtonContext();

    return (
        <ButtonBase
            {...props}
            {...getTagIdFor("pdp-order-button")}
            type={"button"}
            disabled={isDisabled}
            onClick={onSubmit}
        >
            <span className={cn("tw:hidden tw:md:block")}>
                {t("ecommerce.button.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
            <span className={cn("tw:md:hidden")}>
                {t("ecommerce.buttonMobile.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
        </ButtonBase>
    );
};
